'use strict';

var React = require('react');

var SvgShopcodesMajor = function SvgShopcodesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1a1.5 1.5 0 0 0-1.5 1.5v4.5h6v-6h-4.5zm4.5 12h-6v4.5a1.5 1.5 0 0 0 1.5 1.5h4.5v-6zm6-12h4.5a1.5 1.5 0 0 1 1.5 1.5v4.5h-6v-6zm-12 8v2h2v-2h-2zm8-4h2v2h-2v-2zm2-4h-2v2h2v-2zm0 16h1v2h-3v-3h2v1zm8 0h-2v2h.5a1.5 1.5 0 0 0 1.5-1.5v-.5zm-2-4h2v3h-2v-3zm-1 0h-2v6h2v-6zm-3-4h6v2h-6v-2zm-2 0h-6v2h4v3h2v-5zm2 4h1v3h-1z"
  }));
};

exports.SvgShopcodesMajor = SvgShopcodesMajor;
